import { executeApiRequest } from './api-helpers'
import { IApiResponse, IApiCallOptions } from '@pushly/aqe/lib/interfaces'
import aqe from '@pushly/aqe'

export const fetchDomainNotification = async (
    domainId: number,
    notifId: string | number,
    opts: IApiCallOptions,
): Promise<IApiResponse<any[]>> => {
    return await executeApiRequest<any[]>(
        'get',
        `${aqe.defaults.publicApiDomain}/v3/domains/${domainId}/notifications/${notifId}`,
        null,
        opts,
        { data: undefined },
    )
}
